import PropTypes from "prop-types";
import {Typography} from "@material-ui/core";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {useDispatch, useSelector} from "react-redux";
import {useCallback, useEffect, useState} from "react";
import {InitialDialogActions, InitialDialogContent} from "./initial-step/InitialStep";
import {SuccessDialogActions, SuccessDialogContent} from "./success-step/SuccessStep";
import {ConfirmDialogActions, ConfirmDialogContent} from "./confirm-step/ConfirmStep";
import {mapSelectValues} from "./ChangeApnHelper";
import * as actions from "../../../../../../store"
import {useModifyApnForm} from "./useModifyApnForm";

const ChangeApnDialog = (props) => {
    const dispatch = useDispatch()
    const changeApnState = useSelector(state => state.simReducer.changeApn)
    const [step, setStep] = useState(1)
    const [changeApnForm, setChangeApnForm] = useModifyApnForm(
        changeApnState.condivisoApnNames,
        changeApnState.condivisoVrfNames,
        changeApnState.dedicatoApnNames,
        changeApnState.sicurezzaCentralizzataApnNames
    )

    useEffect(() => {
        dispatch(actions.fetchModifyApnOptions(props.sim.iccId))
    }, [dispatch, props.sim.iccId])

    const handleChangeStep = useCallback((step) => {
        setStep(step)
    }, [])

    const dialogs = {
        1: {
            dialogWidth: "md",
            content: <InitialDialogContent changeApnForm={changeApnForm}
                                           apnOptions={changeApnState.apnOptions}
                                           currentApn={props.sim.currentApn}
                                           selectValues={mapSelectValues(changeApnState)}
                                           handleChangeApnForm={setChangeApnForm}/>,
            actions: <InitialDialogActions changeApnForm={changeApnForm}
                                           moveToNextStep={() => handleChangeStep(2)}
                                           handleClose={props.handleClose}/>,
            title: "Modifica tipologia APN"
        },
        2: {
            dialogWidth: "md",
            content: <ConfirmDialogContent changeApnForm={changeApnForm}
                                           apnOptions={changeApnState.apnOptions}
                                           currentApn={props.sim.currentApn}/>,
            actions: <ConfirmDialogActions changeApnForm={changeApnForm}
                                           moveBack={() => handleChangeStep(1)}
                                           moveToConfirm={() => handleChangeStep(3)}
                                           iccId={props.sim.iccId}
                                           loading={changeApnState.loading}
                                           error={changeApnState.error}/>,
            title: "Modifica tipologia APN"
        },
        3: {
            dialogWidth: "xs",
            content: <SuccessDialogContent/>,
            actions: <SuccessDialogActions loadSchedaTecnica={props.loadSchedaTecnica} iccId={props.sim.iccId}
                                           handleClose={props.handleClose}/>,
            title: "Modifica confermata"
        }
    }

    return (
        <GenericDialog open={props.open}
                       loading={changeApnState.fetchLoading}
                       dialogWidth={dialogs[step].dialogWidth}
                       dialogContent={dialogs[step].content}
                       dialogActions={dialogs[step].actions}
                       handleDialogCloseButton={props.handleClose}
                       handleDialogClose={props.handleClose}>
            <Typography variant="h5">{dialogs[step].title}</Typography>
        </GenericDialog>
    )
}

ChangeApnDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    sim: PropTypes.shape({
        iccId: PropTypes.string.isRequired,
        msisdn: PropTypes.string.isRequired,
        currentApn: PropTypes.string.isRequired
    }).isRequired,
    loadSchedaTecnica: PropTypes.bool.isRequired
}

export default ChangeApnDialog
